/** Keyed by the normalised URL, so one link resolves once per session. */
export const LINK_PREVIEW_QUERY_KEY = "link-preview";
